import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { Subject } from 'rxjs';
import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import { AuthService } from '../../core/services/auth.service';
import { UserPersistenceService } from '../../core/services/userPersistence.service';
import { Enums } from '../../shared/models/enums';
import ModalForgotPasswordSchema from '../../shared/schemas/modals/modalForgotPassword.json';
import { FormControlService } from '../../shared/services/form-control.service';
import { FormGroupGenerationService } from '../../shared/services/form-group-generation.service';
import { ToastService } from '../../shared/services/toast.service';
import { InputFieldComponent } from '../../shared/widgets/form/input-field/input-field.component';

@Component({
    selector: 'ifc-modal-forgot-password',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './modal-forgot-password.component.html',
    styleUrls: ['./modal-forgot-password.component.scss'],
    standalone: true,
    imports: [InputFieldComponent, MatButton]
})
export class ModalForgotPasswordComponent implements OnInit {

    form: FormGroup;
    action: Subject<any> = new Subject();
    emailSent = false;
    schema = ModalForgotPasswordSchema;
    confirmationStatus = Enums.confirmationStatus;

    constructor(
        public modalRef: MDBModalRef,
        public userPersistenceService: UserPersistenceService,
        private formControlService: FormControlService,
        private fb: FormBuilder,
        private formGroupGenerationService: FormGroupGenerationService,
        private authService: AuthService,
        private toastService: ToastService,

        private cdr: ChangeDetectorRef) { }

    ngOnInit() {
        this.form = this.fb.group(this.formGroupGenerationService.createFormGroup(this.schema));
        this.updateControlLabel();
    }

    private updateControlLabel() {
        this.schema.properties.email.title = this.userPersistenceService.generalTranslation.Email;
    }

    onCancelClick() {
        this.modalRef.hide();
        window.location.assign('/project/allBuildings');
        this.action.next({ status: this.confirmationStatus.cancel });
    }

    onSendClick() {
        if (this.form.valid) {
            this.authService.forgotPassword(this.form.controls.email.value)
              .subscribe(response => {
                  this.emailSent = true;
              
                  this.cdr.markForCheck();}, (err) => {
                if (err.error.message === '102') {
                    this.toastService.error(this.userPersistenceService.generalTranslation.EmailExist);
                }
                else {
                    this.toastService.error(this.userPersistenceService.generalTranslation.ErrorMsg);
                }
              
                  this.cdr.markForCheck();});
        }
        else {
            this.formControlService.callFormControlError(this.form);
        }
    }

    openLogin() {
        this.modalRef.hide();
        this.action.next({ status: 'login'  });
    }
}
